import http from '../http'
import {ECONOMY_LIST} from '../../services/endpoints'

export function getEconomyList() {
    return http.request({
      url:ECONOMY_LIST,
      method:'get',
    })
  }